import React from 'react';
import {
    Row, Col,
} from 'reactstrap';

import 'react-toastify/dist/ReactToastify.css';

import Widget from '../../../components/Widget';
import s from '../Afiliaciones.module.scss';
import {Table, TableContainer, TableHead, TableBody, TableRow, TableCell} from "@mui/material";


class Comercios extends React.Component{
    render() {
        return (
            <div className={s.root}>
                <Widget>
                    <Row>
                        <Col lg="12" xs="10">
                            <div>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow key={-1}>
                                                <TableCell>NIT</TableCell>
                                                <TableCell>CÓDIGO ÚNICO</TableCell>
                                                <TableCell>NOMBRE COMERCIO</TableCell>
                                                <TableCell>SECCIONAL</TableCell>
                                                <TableCell>ESTADO</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                this.props.data.map(item =>
                                                    (<TableRow key = {item.idinfo_general}>
                                                        <TableCell>{item.nit}</TableCell>
                                                        <TableCell><a href={`/#/app/Detalle?codigo=${item.codigo}`} >{item.codigo}</a></TableCell>
                                                        <TableCell>{item.nombre_comercio}</TableCell>
                                                        <TableCell>{item.seccional}</TableCell>
                                                        {/*<TableCell>{item.telefono1}</TableCell>*/}
                                                        {/*<TableCell>{item.telefono2}</TableCell>*/}
                                                        <TableCell>{item.estado === null || item.estado === 'Sin informacion'? <img title="Sin evidencias" width={25} height={25} src={require('../images/pendent.jpg')} />: <img title="Evidencias cargadas" width={25} height={25} src={require('../images/check.jpg')} />}
                                                        </TableCell>
                                                    </TableRow>))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Col>
                    </Row>
                </Widget>
            </div>
        );
    }

}

export default Comercios;
